import { Controller } from "@hotwired/stimulus"

// Controller específico para manejar el comportamiento de scroll del header nativo
export default class extends Controller {
  connect() {
    console.log('ScrollHeader controller conectado')
    this.lastScrollTop = 0
    this.isAtBottom = false
    this.scrollDirection = null
    this.debounceTimer = null
    this.initScrollBehavior()
  }

  initScrollBehavior() {
    console.log('Iniciando scroll behavior')
    
    this.isInPullToRefresh = false
    
    this.handleScroll = () => {
      // Debounce para evitar demasiadas ejecuciones
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      
      this.debounceTimer = setTimeout(() => {
        this.processScroll()
      }, 16) // ~60fps para suavidad pero menos jittery
    }
    
    this.processScroll = () => {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop)
      const windowHeight = window.innerHeight
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      )
      
      // Detectar si estamos cerca del final de la página (con margen de 100px)
      const isNearBottom = scrollTop + windowHeight >= documentHeight - 100
      const isAtTop = scrollTop <= 10
      
      // Manejar overscroll negativo en iOS (pull-to-refresh)
      const actualScrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (actualScrollTop < -10) {
        this.element.classList.remove('hidden')
        this.isInPullToRefresh = true
        return
      }
      
      // Salir del estado pull-to-refresh
      if (this.isInPullToRefresh && actualScrollTop >= 0) {
        this.isInPullToRefresh = false
      }
      
      // No procesar scroll normal si estamos en pull-to-refresh
      if (this.isInPullToRefresh) {
        return
      }
      
      // Determinar dirección del scroll con threshold 
      const scrollDelta = scrollTop - this.lastScrollTop
      
      // Ignorar cambios muy pequeños, especialmente cerca del final
      const threshold = isNearBottom ? 8 : 5
      if (Math.abs(scrollDelta) < threshold) {
        return
      }
      
      const isScrollingDown = scrollDelta > 0
      const isScrollingUp = scrollDelta < 0
      
      // Lógica principal de visibilidad 
      if (isAtTop) {
        // En el top - siempre mostrar
        this.element.classList.remove('hidden')
        this.isAtBottom = false
      } else if (isScrollingDown && scrollTop > 60) {
        // Scroll hacia abajo - ocultar header (pero no forzar aparición al final)
        this.element.classList.add('hidden')
        this.isAtBottom = isNearBottom
      } else if (isScrollingUp && scrollDelta < -15) {
        // Scroll hacia arriba con momentum suficiente - mostrar header
        this.element.classList.remove('hidden')
        this.isAtBottom = false
      }
      
      // Solo mostrar automáticamente en el final si el usuario hizo scroll hacia arriba recientemente
      if (isNearBottom && !this.element.classList.contains('hidden') && this.isAtBottom) {
      
      }
      
      // Actualizar el último scroll top solo si no es el bounce de iOS
      if (actualScrollTop >= 0) {
        this.lastScrollTop = scrollTop
      }
    }
    
    // Touch events para iOS
    this.handleTouchStart = (e) => {
      this.touchStartY = e.touches[0].clientY
      this.touchStartTime = Date.now()
    }
    
    this.handleTouchEnd = (e) => {
      // Manejar el final del touch para detectar bounce
      const touchEndTime = Date.now()
      const touchDuration = touchEndTime - (this.touchStartTime || 0)
      
      // Si el touch fue muy corto, podría ser un bounce
      if (touchDuration < 100) {
        setTimeout(() => {
          const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop)
          if (scrollTop <= 10) {
            this.element.classList.remove('hidden')
          }
        }, 50)
      }
    }
    
    this.handleTouchMove = (e) => {
      if (!this.touchStartY) return
      
      const touchY = e.touches[0].clientY
      const touchDelta = touchY - this.touchStartY
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      
      // Pull-to-refresh detection
      if (scrollTop <= 5 && touchDelta > 50) {
        this.element.classList.remove('hidden')
        this.isInPullToRefresh = true
      }
    }
    
    // Event listeners con configuración optimizada para iOS
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('touchstart', this.handleTouchStart, { passive: true })
    window.addEventListener('touchmove', this.handleTouchMove, { passive: true })
    window.addEventListener('touchend', this.handleTouchEnd, { passive: true })
    
    // Listener adicional para resize (cambios de orientación en mobile)
    this.handleResize = () => {
      setTimeout(() => {
        this.processScroll()
      }, 100)
    }
    window.addEventListener('resize', this.handleResize, { passive: true })
    
    console.log('Event listeners agregados')
  }

  disconnect() {
    
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    
    // Limpiar event listeners cuando se destruya el controller
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll)
    }
    if (this.handleTouchStart) {
      window.removeEventListener('touchstart', this.handleTouchStart)
    }
    if (this.handleTouchMove) {
      window.removeEventListener('touchmove', this.handleTouchMove)
    }
    if (this.handleTouchEnd) {
      window.removeEventListener('touchend', this.handleTouchEnd)
    }
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
    console.log('ScrollHeader controller desconectado')
  }
}
